import type { PolicyDocument } from '../../types/policy';
import { company as c } from '../company';

export const safetyPolicy: PolicyDocument = {
  title: 'Product Safety & Use',
  lead: 'Read before installing, charging or using your M1 PRO. Keep these instructions.',
  sections: [
    {
      id: 'purpose',
      heading: 'Intended use',
      blocks: [
        'The M1 PRO is battery-powered decorative accent lighting for residential pools, spas and outdoor spaces. It is not safety, emergency, navigation or code-required lighting, and must not be relied on to see hazards, swimmers or obstacles. Always keep your pool’s required lighting operational.',
      ],
    },
    {
      id: 'water',
      heading: 'Water safety',
      blocks: [
        {
          list: [
            'Never leave children unattended in or near water. Lights in the water can attract children.',
            'Install and remove lights only when no one is swimming. Do not dive or swim to retrieve lights without proper supervision.',
            'Do not use lights as toys or floatation devices.',
            'Make sure the lights and bases do not create a tripping or snagging hazard on steps, ledges or walkways.',
          ],
        },
      ],
    },
    {
      id: 'magnets',
      heading: 'WARNING — Strong magnets',
      blocks: [
        'The light and Magnetic Mount System contain powerful magnets. Swallowed magnets can stick together across the intestines and cause serious injury or death. Keep away from children and pets. Seek immediate medical attention if a magnet is swallowed or inhaled.',
        'Keep magnets away from pacemakers and other implanted medical devices, credit cards, phones and electronic media.',
      ],
    },
    {
      id: 'battery',
      heading: 'WARNING — Lithium battery and charging',
      blocks: [
        {
          list: [
            'Remove the light from the water and dry it completely before opening the USB-C cover.',
            'Never charge while wet, in the water, in direct sun, or near flammable materials. Charge indoors on a hard, non-flammable surface and do not leave charging unattended.',
            'Use a standard 5 V USB power adapter and the supplied or a certified USB-C cable.',
            'Close and fully seat the blue USB-C cover after charging, before returning the light to water.',
            'Stop using the light if it becomes hot, swollen, cracked, leaks, smells unusual or the cover is damaged.',
            'Do not puncture, crush, disassemble, heat or incinerate. Dispose of and recycle batteries according to local regulations.',
          ],
        },
      ],
    },
    {
      id: 'remote',
      heading: 'Remote control batteries',
      blocks: [
        {
          list: [
            'The remote control uses 2 AAA batteries (not included). Keep batteries and the remote out of reach of children.',
            'Insert batteries with correct polarity. Do not mix old and new batteries or different battery types.',
            'Remove batteries if the remote will not be used for an extended period. Dispose of used batteries according to local regulations.',
            'Keep the remote dry and do not submerge it in pool or spa water.',
          ],
        },
      ],
    },
    {
      id: 'install',
      heading: 'Installation',
      blocks: [
        'Install only on clean, smooth, dry surfaces described in the instructions. Test the attachment before use. Do not install on damaged surfaces or where mounting could damage liners or finishes. You are responsible for checking compatibility with your pool or spa surface and for any damage caused by installation or removal.',
      ],
    },
    {
      id: 'environment',
      heading: 'Environment and maintenance',
      blocks: [
        'Remove lights before shock treatments, acid washing, draining, freezing temperatures, or winterizing. Rinse with fresh water periodically and store dry when not in use. For salt water, marine, high-chlorine or extreme-temperature use, contact us before installing.',
      ],
    },
    {
      id: 'eyes',
      heading: 'Light exposure',
      blocks: ['Do not stare directly into the LEDs at close range.'],
    },
    {
      id: 'fcc',
      heading: 'Regulatory information',
      blocks: [
        'This device may contain wireless components. Operation is subject to the following two conditions: (1) this device may not cause harmful interference, and (2) this device must accept any interference received, including interference that may cause undesired operation. Changes or modifications not expressly approved by the party responsible for compliance could void the user’s authority to operate the equipment.',
      ],
    },
    {
      id: 'contact',
      heading: 'Questions',
      blocks: [`Contact ${c.supportEmail} before using the product if you have any questions.`],
    },
  ],
};
